import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import { AccouncementsSection, BrandAssetSection, NewsroomCarousel, NewsroomHeaderSection, PressMentionsSection } from '@sections/newsroom';
import { Layout, Seo } from '@layout';
import { AbcSection } from '@sections/shared/AbcSection';
import { Box } from '@components/Box';
import { TextPairing } from '@components/TextPairing';
import { newsroomPageData } from '@data-ts/pages/newsroom';

const Newsroom = () => {
  return (
    <Layout>
      <Seo title={newsroomPageData.seoText} canonicalURL={'https://withjoy.com/newsroom/'} />
      <NewsroomCarousel features={newsroomPageData.carousel} />
      <NewsroomHeaderSection />
      <PressMentionsSection pressNodes={newsroomPageData.features} backgroundColor="mono7" />
      <AccouncementsSection announcementsNodes={newsroomPageData.announcements} />
      <BrandAssetSection />
      <Box marginBottom={[12, 12, 15]} marginTop={[12]} marginX={8} backgroundColor="mono7">
        <TextPairing
          title="Contact Us"
          titleColor="purple6"
          titleVariant="hed72Hero"
          titleTagName="h2"
          alignment="center"
          bodyColor="purple6"
          bodyVariant="dek20"
          body={ReactHtmlParser(newsroomPageData.content)}
        />
      </Box>
      <AbcSection />
    </Layout>
  );
};

export default Newsroom;
